var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "#000",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.617 1.309L9.732 3.982c-.077.11-.122.239-.131.373a.73.73 0 0 0 .081.387c.062.119.155.219.27.288a.74.74 0 0 0 .38.106h1.153v12.835a.73.73 0 0 0 .215.517c.068.068.149.122.238.159a.73.73 0 0 0 .56 0 .72.72 0 0 0 .237-.159.73.73 0 0 0 .214-.518V5.136h1.153c.134 0 .266-.037.38-.106s.208-.169.27-.288a.73.73 0 0 0 .081-.387c-.009-.134-.054-.263-.131-.373l-1.885-2.673a.73.73 0 0 0-.262-.229c-.104-.054-.22-.083-.338-.083a.72.72 0 0 0-.338.083.75.75 0 0 0-.262.229zm5.302 3.669a.73.73 0 0 0 .267 1c1.894 1.093 3.375 2.781 4.212 4.802s.984 4.261.418 6.373a9.94 9.94 0 0 1-3.548 5.311 9.93 9.93 0 0 1-6.048 2.053c-2.187 0-4.313-.722-6.048-2.053a9.93 9.93 0 0 1-3.548-5.311c-.566-2.113-.419-4.353.418-6.373s2.317-3.708 4.212-4.802a.73.73 0 1 0-.733-1.267 11.4 11.4 0 0 0 5.7 21.273 11.4 11.4 0 0 0 5.7-21.272.73.73 0 0 0-1 .267z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1dcef6f9015858d5107161371b2da594.svg";
export { ForwardRef as ReactComponent };